import { SET_CAROUSEL_TOP_HEIGHT } from 'actions';
import { CarouselReduxReducer } from 'typings';

export function setCarouselTopHeight(
  reduxReducer: CarouselReduxReducer,
  topHeight: number,
) {
  return { reduxReducer, topHeight, type: SET_CAROUSEL_TOP_HEIGHT };
}
